import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { FeatureID } from 'src/app/moov-common/enum/feature.enum';
import { Locale } from 'src/app/moov-common/enum/locale.enum';
import { GenderPipe } from 'src/app/moov-common/pipes/gender.pipe';
import { StructuredProcessInstanceStatusEnum } from 'src/app/moov-common/services/chat/strcutredProcess-data';
import { DiscoveryTypeEnum } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';

@Component({
  selector: 'app-structured-process-intro-consent',
  templateUrl: './structured-process-intro-consent.component.html',
  styleUrls: ['./structured-process-intro-consent.component.scss']
})
export class StructuredProcessIntroConsentComponent extends BaseComponent implements OnInit, OnChanges {
  @Input() currentStepStatus: number;
  @Output() consentApproved = new EventEmitter<void>();
  @Output() discoveryCompleted = new EventEmitter<void>();

  phase: 'consent' | 'discovery' = 'consent';
  eDiscoveryTypeEnum = DiscoveryTypeEnum;
  imageRootFolder = "assets/common/";
  discoveryAssetsFolder = "assets/discovery/";
  videoAssetsFolder = 'assets/media/questions/';
  introVideoAssetName: string = "";
  approvePrivaceyPolicyCheckbox: boolean = false;
  presentConsultantVideo: boolean = false;
  isVideoMuted: boolean = false;
  introText: string = "";
  showMoreDetailsButtonHeader: string = "";
  showMoreTextDetails: boolean = false;
  @ViewChild('introVideo') introVideo: ElementRef;

  constructor(
    private readonly translate: TranslateService,
    private readonly genderSerivce: GenderPipe,
    private readonly personalUserService: AbstractPersonalUserDataService
  ) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentStepStatus'] && !changes['currentStepStatus'].firstChange) {
      if (this.currentStepStatus == StructuredProcessInstanceStatusEnum.PENDING) {
        this.phase = 'consent';
        this.approvePrivaceyPolicyCheckbox = false;
      } else if (this.currentStepStatus == StructuredProcessInstanceStatusEnum.IN_PROGRESS
                 || this.currentStepStatus == StructuredProcessInstanceStatusEnum.COMPLETED) {
        // the step was already approved - never leave the user on the consent screen, approving it again
        // would restart the journey
        this.approvePrivaceyPolicyCheckbox = true;
        this.phase = 'discovery';
      }
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.currentStepStatus == StructuredProcessInstanceStatusEnum.COMPLETED
        || this.currentStepStatus == StructuredProcessInstanceStatusEnum.IN_PROGRESS) {
      this.approvePrivaceyPolicyCheckbox = true;
      this.phase = 'discovery';
    }
    this.introVideoAssetName = this.utilsService.buildVideoNameByGenderAndLocale(this.videoAssetsFolder + 'intro', '.mp4', this.user!);
    this.verifyPresentQuestionsVideos();
    this.calculateMessageText();
  }

  verifyPresentQuestionsVideos(): void {
    this.personalUserService.verifyFeature(FeatureID.discoveryConsultantQuestionsVideos).subscribe(res => {
      this.presentConsultantVideo = res;
    });
  }

  get isSubmitDisabled(): boolean {
    return !this.approvePrivaceyPolicyCheckbox;
  }

  onSubmit(): void {
    if (this.approvePrivaceyPolicyCheckbox) {
      // the parent persists IN_PROGRESS and passes it back down - ngOnChanges then moves to the questionnaire
      this.consentApproved.emit();
    }
  }

  onDiscoveryCompleted(): void {
    this.discoveryCompleted.emit();
  }

  goToPrivacyStatement(): void {
    let privacyUrl: string = "";
    if (this.user?.locale == Locale.he_IL) {
      privacyUrl = '/assets/static/privacy/he/Claro_Privay_Policy.htm';
    } else {
      privacyUrl = '/assets/static/privacy/en/Claro_Privay_Policy.htm';
    }
    window.open(privacyUrl);
  }

  playVideo(): void {
    if (!this.presentConsultantVideo) {
      return;
    }
    const media = this.introVideo.nativeElement;
    media.muted = this.isVideoMuted;
    media.play();
  }

  muteConsultantVideo(): void {
    this.isVideoMuted = !this.isVideoMuted;
    const media = this.introVideo.nativeElement;
    media.muted = this.isVideoMuted;
  }

  toggleShowMoreText(): void {
    this.showMoreTextDetails = !this.showMoreTextDetails;
    this.calculateMessageText();
  }

  calculateMessageText(): void {
    this.translate.stream(this.genderSerivce.transform("firstTime.messageText")).subscribe(fullMessageText => {
      const messageTextCutOut = this.translate.instant("firstTime.messageTextCutOut");
      const index = fullMessageText.indexOf(messageTextCutOut) + messageTextCutOut.length;

      if (this.showMoreTextDetails) {
        this.showMoreDetailsButtonHeader = this.translate.instant("common.showLessTextLabel");
        this.introText = fullMessageText;
      } else {
        this.showMoreDetailsButtonHeader = this.translate.instant("common.showMoreTextLabel");
        this.introText = fullMessageText.substring(0, index);
        if (this.introText.length < fullMessageText.length) {
          this.introText += "...";
        }
      }
    });
  }
}
